import * as React from 'react'
import type { SVGProps, Ref } from 'react'
import { forwardRef } from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgToseeSaderat = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 24 24'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <g clipPath='url(#tosee_saderat_svg__a)'>
      <path
        fill='#046B10'
        d='M6.958.095C8.814.052 10.675.083 12.533.07c1.256-.13 2.523-.037 3.783-.068.216.021.48-.06.653.109.738.65 1.383 1.381 2.099 2.056 1.429 1.428 2.88 2.833 4.314 4.256.201.203.433.38.593.62q.027.223.02.447c-.009 3.132.014 6.263 0 9.394-.15.277-.412.465-.623.692q-3.182 3.177-6.344 6.374c-2.145.03-4.292-.024-6.435.047H7.272c-.254.017-.407-.21-.577-.357-2.167-2.135-4.314-4.291-6.496-6.412a.43.43 0 0 1-.161-.343C.003 13.817.02 10.747 0 7.675c.007-.2-.017-.407.034-.604.54-.622 1.166-1.164 1.728-1.767 1.414-1.413 2.813-2.842 4.23-4.251.324-.319.619-.668.968-.958zM8.412 3.75c-1.214 1.24-2.45 2.461-3.668 3.7-.369.377-.766.737-1.093 1.156-.065.172-.029.362-.038.542.022 2.118-.018 4.237.022 6.35.253.314.566.572.851.857 1.27 1.28 2.573 2.527 3.851 3.8.325.404.895.213 1.338.212 1.954-.016 3.908 0 5.862-.025 1.577-1.65 3.205-3.252 4.818-4.867.027-1.433-.033-2.869.033-4.3-.068-.879-.005-1.76-.048-2.64-1.509-1.555-3.088-3.053-4.608-4.605-.125-.117-.234-.303-.432-.286-2.153-.006-4.307 0-6.458 0-.146.011-.324-.024-.426.108zm1.212 2.473c.79-.863 1.646-1.658 2.449-2.512 1.712 1.7 3.404 3.42 5.109 5.127 1.022 1.063 2.097 2.076 3.097 3.16-.767.948-1.687 1.758-2.511 2.654-.166.234-.462.157-.71.167-1.506-.006-3.01 0-4.514 0 .89-.961 1.836-1.874 2.748-2.817-.99-1.032-2.017-2.03-3.016-3.055-.884-.907-1.82-1.766-2.652-2.721zM6.312 9.3c.14-.184.391-.114.589-.13 1.544.014 3.089-.023 4.632.019-.884.963-1.845 1.855-2.722 2.827.263.354.61.633.906.957 1.542 1.533 3.062 3.088 4.598 4.626.043.067.195.171.092.25-.818.797-1.6 1.634-2.426 2.422-2.636-2.611-5.23-5.263-7.853-7.887a8 8 0 0 1-.35-.376c.788-.955 1.704-1.793 2.535-2.708'
      />
    </g>
    <defs>
      <clipPath id='tosee_saderat_svg__a'>
        <path fill='#fff' d='M0-.002h24v24H0z' />
      </clipPath>
    </defs>
  </svg>
)
const ForwardRef = forwardRef(SvgToseeSaderat)
export default ForwardRef
